import Splide from "@splidejs/splide";
import EmblaCarousel from "embla-carousel";
import {ga4TrackSimpleEvent} from "../modules/analytics";
import {isDesktop, isMobile} from "../modules/devices";
import {
    calculateCustomSizePrice,
    calculatePrice,
    getDataAddToCart,
    getMultiSizeProducts,
    getOptions,
    getSizesPrices,
    getSvgPreviewImage,
    sendEventsAddToCart,
    trackProductPageGa4Events
} from "./product";
import {fadeIn, fadeOut, slideDown} from "./element-visibility";
import {adjustArrows} from "./recommenders";
import {formatPrice} from "./price";
import {addItem, addItems, openCart, updateItemsNumber} from "./cart";
import {showOffcanvas} from "./offcanvas";
import {hideElement} from "../modules/element-visibility";
import {fireChangeEvent, fireInputEvent} from "../modules/events";
import {showCollapse} from "./collapse";
import CssFilterConverter from 'css-filter-converter';
import {isPremiumUser} from "./user";

let imageSlider = null;
export function initImageSlider(slider, productType)
{
    imageSlider = null;
    let emblaPrevButton = slider.closest('.embla-container').querySelector('.embla-prev-button');
    let emblaNextButton = slider.closest('.embla-container').querySelector('.embla-next-button');
    let emblaPaginator = slider.closest('.embla-container').querySelector('.embla-pagination');
    let emblaCarousel = EmblaCarousel(slider);

    emblaPrevButton.addEventListener('click', emblaCarousel.scrollPrev, false);
    emblaNextButton.addEventListener('click', emblaCarousel.scrollNext, false);

    emblaCarousel.on('select', function() {
        if (emblaCarousel.canScrollPrev() && emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.remove('d-none');
        if (!emblaCarousel.canScrollPrev() && !emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.add('d-none');
        if (emblaCarousel.canScrollNext() && emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.remove('d-none');
        if (!emblaCarousel.canScrollNext() && !emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.add('d-none');

        let previousSlideIndex = emblaCarousel.previousScrollSnap();
        let nextSlideIndex = emblaCarousel.selectedScrollSnap();

        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${previousSlideIndex}"]`).classList.remove('bg-black');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${previousSlideIndex}"]`).classList.add('bg-gray-light');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${nextSlideIndex}"]`).classList.remove('bg-gray-light');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${nextSlideIndex}"]`).classList.add('bg-black');
        emblaPaginator.querySelector('.number-of-page').innerHTML = parseInt(nextSlideIndex) + 1;

        ga4TrackSimpleEvent({
            event: 'product_page',
            method: 'image_scroll',
            product_type: productType || '-'
        });
    });

    imageSlider = emblaCarousel;
}

export function initRecommender(recommender, productType)
{
    let emblaPrevButton = recommender.closest('.embla-container').querySelector('.embla-prev-button');
    let emblaNextButton = recommender.closest('.embla-container').querySelector('.embla-next-button');
    let emblaCarousel = EmblaCarousel(
        recommender,
        {
            loop: false,
            align: 'start',
            slidesToScroll: isMobile() ? 1 : 'auto',
            watchDrag: isMobile()
        }
    );

    //ALIGN BUTTONS
    let imageHeight = recommender.querySelector('img').offsetHeight;
    let arrowTop = imageHeight / 2;
    emblaPrevButton.style.top = arrowTop + "px";
    emblaNextButton.style.top = arrowTop + "px";

    //BUTTONS FUNCTIONALITY
    if (emblaCarousel.canScrollPrev()) emblaPrevButton.disabled = false;
    if (emblaCarousel.canScrollNext()) emblaNextButton.disabled = false;

    emblaPrevButton.addEventListener('click', emblaCarousel.scrollPrev, false);
    emblaNextButton.addEventListener('click', emblaCarousel.scrollNext, false);

    emblaCarousel.on('select', function() {
        if (emblaCarousel.canScrollPrev() && emblaPrevButton.disabled) emblaPrevButton.disabled = false;
        if (!emblaCarousel.canScrollPrev() && !emblaPrevButton.disabled) emblaPrevButton.disabled = true;
        if (emblaCarousel.canScrollNext() && emblaNextButton.disabled) emblaNextButton.disabled = false;
        if (!emblaCarousel.canScrollNext() && !emblaNextButton.disabled) emblaNextButton.disabled = true;
    });

    //LAZYLOAD FUNCTIONALITY
    let slidesLoaded = [];
    emblaCarousel.on('slidesInView', function() {
        let slidesInView = emblaCarousel.slidesInView().filter((index) => !slidesLoaded.includes(index));

        slidesInView.forEach(function(slideIndex) {
            let slide = emblaCarousel.slideNodes()[slideIndex];
            if (!slide) return;
            let img = slide.querySelector('img');
            let loader = slide.querySelector('.loader');

            img.src = img.dataset.src;
            img.addEventListener('load', function() {
                loader.classList.add('d-none');
                slidesLoaded.push(slideIndex);
            });
        });
    });
}

export function resetPreviewImage(container, forceGenerateImage = true, forcedProductIndex = null)
{
    let activeProductOptions = container.querySelector('.pi-options.show') || container;
    let productIndex = forcedProductIndex || activeProductOptions.dataset.productIndex || 1;
    let imageSlider = container.querySelector(`.image-slider .embla-slide[data-type="preview"][data-product-index="${productIndex}"]`);
    if (!imageSlider) return;
    let image = imageSlider.querySelector('img');

    if (imageSlider.dataset.default) image.src = imageSlider.dataset.default;
}

export async function renderPreviewImage(container, forceGenerateImage = true, forcedProductIndex = null)
{
    let activeProductOptions = container.querySelector('.pi-options.show') || container;
    let productIndex = forcedProductIndex || activeProductOptions.dataset.productIndex || 1;
    let optionsContainer = container.querySelector(`.pi-options[data-product-index="${productIndex}"]`);
    let customText = optionsContainer.querySelector(`input[name="customText"], textarea[name="customText"]`);
    let color = optionsContainer.querySelector(`input[name="color"]:checked`);
    let colorHex = color ? color.dataset.previewColor : null;
    color = color ? color.value : null;
    let imageSlider = container.querySelector(`.image-slider .embla-slide[data-type="preview"][data-product-index="${productIndex}"]`);
    if (!imageSlider) return;
    let image = imageSlider.querySelector('img');
    let svgPersonalizedText = optionsContainer.querySelector('input[name="svg-personalized-text"], input#svg-personalized-text');
    let personalizedSvg = optionsContainer.querySelector('input[name="personalizedSvg"]');
    let generateSVGPersonalizedText = optionsContainer.querySelector('input[name="generate-svg-personalized-text"]');
    let factor = optionsContainer.querySelector('input[name="factor"]');
    let options = getOptions(container);
    let bgColor = document.querySelector('#bg-color-'+productIndex);
    if (bgColor) bgColor = bgColor.value;
    let frame = optionsContainer.querySelector('input[name="poster-frame"]:checked');

    if (!frame) window.scrollTo({top: imageSlider, behavior: 'smooth'});
    if (personalizedSvg) personalizedSvg.value = '';
    if (svgPersonalizedText) svgPersonalizedText.dataset.preview = '';

    showImageSliderLoader();

    if (customText && customText.value !== '' && svgPersonalizedText) {
        let productId = container.dataset.productId;
        if (forceGenerateImage) {
            let svgResponse = await getSvgPreviewImage(productId, customText.value, color);
            let svgPreview = svgResponse.svgPreview;
            let svgData = svgResponse.svgData;
            if (svgPreview) {
                svgPersonalizedText.dataset.preview = svgPreview;
                await fadeOut(image, 50);
                image.src = '/upload/tmp/' + svgPreview;
                fadeIn(image, 50);
            }
            if (svgData) {
                generateSVGPersonalizedText.value = svgData.text;
                generateSVGPersonalizedText.dataset.svgFile = svgData.svgFile;
                generateSVGPersonalizedText.dataset.color = svgData.color;
                generateSVGPersonalizedText.dataset.font = svgData.font;
                generateSVGPersonalizedText.dataset.rightToLeft = svgData.rightToLeft;
                factor.value = svgData.factor;
            }
        }

        if (options['mirrored'] && options['mirrored'] === true) image.setAttribute('style', 'transform: scaleX(-1)');
        else image.setAttribute('style', '');
    } else if (frame) {
        if (frame.dataset.color !== '') {
            image.classList.add('frame');
            image.style.borderColor = frame.dataset.color;
        } else {
            image.classList.remove('frame');
            image.style.borderColor = '';
        }
    } else {
        if (colorHex && colorHex.includes("ffffff")) bgColor = '#000000';
        imageSlider.style.backgroundColor = bgColor;
        if (colorHex) image.style.filter = CssFilterConverter.hexToFilter(colorHex.trim())['color'];
        else image.style.filter = '';
        if (options['mirrored'] && options['mirrored'] === true) image.style.transform = 'scaleX(-1)';
        else image.style.transform = '';
    }

    hideImageSliderLoader();
    changeSliderSlideVisible(imageSlider.dataset.position);
}

export function changeSliderSlideVisible(number)
{
    if (!imageSlider) return;
    imageSlider.scrollTo(parseInt(number));
}

export async function updatePriceElements(container)
{
    let sizesSelected = container.querySelectorAll('input[name="size"]:checked');
    let sizeSelected = sizesSelected.length === 1 ? sizesSelected[0] : null;
    let currentPrice = sizeSelected ? sizeSelected.dataset.price : null;
    let oldPrice = sizeSelected ? sizeSelected.dataset.oldPrice : null;
    showLoaderAddToCartButtons(container);
    let [price, premiumPrice] = await calculatePrice(container);
    if (parseFloat(price) > parseFloat(currentPrice)) oldPrice = null;

    if (!price) {
        let oldPriceElement = container.querySelector('.general-information .old-price .number');
        let oldPrice = oldPriceElement ? parseFloat(oldPriceElement.dataset.defaultOldPrice) : null;

        container.querySelectorAll('.general-information .price .price-value').forEach((element) => element.innerHTML = element.dataset.defaultPrice);
        container.querySelectorAll('.general-information .price .price-of').forEach((element) => element.classList.remove('d-none'));
        container.querySelectorAll('.general-information .old-price').forEach(function(element) {
            if (oldPrice) {
                element.querySelector('.number').innerHTML = formatPrice(oldPrice);
                element.classList.remove('d-none');
            } else if (!element.classList.contains('d-none')) element.classList.add('d-none');
        });
        container.querySelectorAll('.general-information .price .price-text').forEach(function (element) {
            if (oldPrice && !element.classList.contains('text-danger')) element.classList.add('text-danger');
            else if (!oldPrice) element.classList.remove('text-danger');
        });
    } else {
        price = formatPrice(price);
        container.querySelectorAll('.general-information .price .price-value').forEach((element) => element.innerHTML = price);
        container.querySelectorAll('.general-information .price .price-of').forEach((element) => element.classList.add('d-none'));

        if (oldPrice) {
            oldPrice = formatPrice(oldPrice);
            container.querySelectorAll('.general-information .old-price').forEach(function (element) {
                let number = element.querySelector('.number');
                if (number) number.innerHTML = oldPrice;
                if (element.classList.contains('d-none')) element.classList.remove('d-none');
            });
            container.querySelectorAll('.general-information .price .price-text').forEach(function (element) {
                if (!element.classList.contains('text-danger')) element.classList.add('text-danger');
            });
        } else {
            container.querySelectorAll('.general-information .old-price').forEach(function (element) {
                if (!element.classList.contains('d-none')) element.classList.add('d-none');
            });
            container.querySelectorAll('.general-information .price .price-text').forEach(function (element) {
                if (element.classList.contains('text-danger')) element.classList.remove('text-danger');
            });
        }
    }

    if (!premiumPrice) {
        container.querySelectorAll('.general-information .premium-price .price-value').forEach((element) => element.innerHTML = element.dataset.defaultPrice);
        container.querySelectorAll('.general-information .premium-price .price-of').forEach((element) => element.classList.remove('d-none'));
    } else {
        premiumPrice = formatPrice(premiumPrice);
        container.querySelectorAll('.general-information .premium-price .price-value').forEach((element) => element.innerHTML = premiumPrice);
        container.querySelectorAll('.general-information .premium-price .price-of').forEach((element) => element.classList.add('d-none'));
    }

    hideLoaderAddToCartButtons(container);
}

export function showLoaderAddToCartButtons(container)
{
    container.querySelectorAll('.btn-add-to-cart').forEach((button) => showLoaderAddToCartButton(button));
}

function hideLoaderAddToCartButtons(container)
{
    container.querySelectorAll('.btn-add-to-cart').forEach((button) => hideLoaderAddToCartButton(button));
}

export function showLoaderAddToCartButton(button)
{
    button.disabled = true;
    let loader = button.querySelector('.loader');
    let elementToHide = button.querySelector('.text');
    elementToHide.classList.add('d-none');
    if (loader) loader.classList.remove('d-none');
}

export function hideLoaderAddToCartButton(button)
{
    button.disabled = false;
    let loader = button.querySelector('.loader');
    let elementToHide = button.querySelector('.text');
    if (loader) loader.classList.add('d-none');
    elementToHide.classList.remove('d-none');
}

export async function addToCart(container)
{
    let data = getDataAddToCart(container);

    showLoaderAddToCartButtons(container);

    let activeProductOptions = container.querySelector('.pi-options.show') || container;
    let header = document.querySelector('header');
    let response = await addItem(data);
    let error = response.error;
    let message = response.message;
    let type = parseErrorType(response.type);
    let items = response.items;
    let productIndex = response.productIndex;
    let productMessage = response.productMessage;
    let activeProductIndex = activeProductOptions ? activeProductOptions.dataset.productIndex : 1;

    hideLoaderAddToCartButtons(container);

    if (error) {
        if (productIndex != activeProductIndex) {
            let optionsContainer = container.querySelector(`.pi-options[data-product-index="${productIndex}"]`)
            let errorElement = container.querySelector(`.error.product-error[data-product-index="${productIndex}"]`);
            let eventData = productIndex;
            let modelOption = optionsContainer.querySelector('.options[data-type="model"]');

            if (!optionsContainer) return;

            if (errorElement) {
                errorElement.innerHTML = productMessage;
                slideDown(errorElement);
            }

            showCollapse(optionsContainer.id);
            window.scrollTo(
                {
                    top: activeProductOptions.getBoundingClientRect().top + window.scrollY - header.offsetHeight,
                    behavior: "smooth",
                }
            );
            if (modelOption) eventData = modelOption.dataset.modelsType+'_'+eventData;
            trackProductPageGa4Events('AddToCartMultiProductError', eventData);
        } else {
            let option = activeProductOptions.querySelector(`.options[data-type="${type}"]`);
            if (!option) return;
            let errorElement = option.querySelector('.error.general-error');

            if (errorElement) {
                errorElement.innerHTML = message;
                slideDown(errorElement);
            }

            if (option.classList.contains('offcanvas')) {
                showOffcanvas(option.id);
                option.querySelector('.offcanvas-body').scrollTop = 0;
            } else {
                window.scrollTo(
                    {
                        top: activeProductOptions.getBoundingClientRect().top + window.scrollY - header.offsetHeight,
                        behavior: "smooth",
                    }
                );
            }

            trackProductPageGa4Events('AddToCartError', type);
        }
    } else {
        openCart();
        updateItemsNumber(true);
        resetForm(container);
        trackProductPageGa4Events('AddToCart');
        sendEventsAddToCart(items);
    }
}

export async function addToCartMultiSize(container)
{
    let products = getMultiSizeProducts(container);

    showLoaderAddToCartButtons(container);

    let response = await addItems(products);
    let error = response.error;
    let message = response.message;
    let type = parseErrorType(response.type);
    let items = response.items;

    hideLoaderAddToCartButtons(container);

    if (error) {
        let option = container.querySelector(`.options[data-type="${type}"]`);
        if (!option) return;
        let errorElement = option.querySelector('.error.general-error');

        if (errorElement) {
            errorElement.innerHTML = message;
            slideDown(errorElement);
        }

        if (option.classList.contains('offcanvas')) {
            showOffcanvas(option.id);
            option.querySelector('.offcanvas-body').scrollTop = 0;
        }

        trackProductPageGa4Events('AddToCartError', type);
    } else {
        openCart();
        updateItemsNumber(true);
        resetForm(container);
        trackProductPageGa4Events('AddToCart');
        sendEventsAddToCart(items);
    }
}

function parseErrorType(type)
{
    if (type === 'tissue') type = 'blind-tissue';
    if (type === 'drop') type = 'blind-drop';
    if (type === 'modelSize') type = 'model-size';
    if (type === 'materialColor') type = 'material-color';
    if (type === 'support-color') type = 'blind-support-color';

    return type;
}

export function resetForm(container)
{
    resetQuantity(container);
    resetPreviews(container);
    resetOptions(container);
    resetComplements(container);
    resetUpSellingPersonalizedText(container);
    resetCrossSellings(container);
    updatePriceElements(container);
}

export function resetQuantity(container)
{
    container.querySelectorAll('.quantity-add-to-cart').forEach(function(element) {
        element.value = element.min || 1;
    });
}

export function resetPreviews(container)
{
    container.querySelectorAll('.options .option-selectable .preview').forEach(function(preview) {
        preview.innerHTML = '';
    });
}

export function resetOptions(container)
{
    container.querySelectorAll('.options, .option-single-value').forEach(function (option) {
        hideOptionWarnings(option);
        hideOptionErrors(option);
        hideOptionCollapse(option);
        switch (option.dataset.type) {
            case 'size':
                resetSizeOption(option);
                break;
            case 'pack':
                resetPackOption(option);
                break;
            case 'color':
                resetColorOption(option);
                break;
            case 'customizer':
                resetCustomizerOption(option);
                break;
            case 'glass-reversed':
                resetGlassReversedOptions(option);
                break;
            case 'orientation':
                resetOrientationOption(option);
                break;
            case 'blind-tissue':
                resetBlindTissueOption(option);
                break;
            case 'blind-chain':
                resetBlindChainOption(option);
                break;
            case 'blind-drop':
                resetBlindDropOption(option);
                break;
            case 'blind-support-color':
                resetBlindSupportColor(option);
                break;
            case 'model':
                resetModelOption(option);
                break;
            case 'material-color':
                resetMaterialColorOption(option);
                break;
            case 'model-size':
                resetModelSizeOption(option);
                break;
            case 'poster-frame':
                resetFrameOption(option);
                break;
            case 'material-canvas':
                resetMaterialCanvasOption(option);
                break;
            case 'vinyl-rug-format':
                resetVinylRugFormat(option);
                break;
        }
    });
}

export function hideOptionWarnings(container)
{
    container.querySelectorAll('.warning').forEach(warning => hideElement(warning));
}

export function hideOptionErrors(container)
{
    container.querySelectorAll('.error').forEach(error => hideElement(error));
    if (container.closest('.product-scope')) container.closest('.product-scope').querySelectorAll('.error.product-error').forEach(error => hideElement(error));
}

export function hideOptionCollapse(container)
{
    container.querySelectorAll('.box-collapse:not(.unique-option, .show-expanded)').forEach(function(box) {
        let collapse = Collapse.getInstance(box.querySelector('.collapse'));
        if (collapse) collapse.hide();
    });
}

export function resetSizeOption(container)
{
    let sizesSelected = container.querySelectorAll('.size.selected');
    let radioButtons = container.querySelectorAll('input[name="size"]:checked');
    let quantitySelectors = container.querySelectorAll('.quantity-selector');
    let confirmButton = container.querySelector('.confirm-button');
    let defaultSize = container.querySelector('input[name="size"].default-size');
    let defaultSizeContainer = container.querySelector('.size.default-size');

    sizesSelected.forEach(function(sizeSelected) {
        let input = container.querySelector(`input[name="size"]#${sizeSelected.htmlFor}`);
        sizeSelected.classList.remove('selected');
        if (input) sizeSelected.querySelector('.size-price').innerHTML = input.dataset.price;
        if (sizeSelected.classList.contains('wallpaper-calculator')) resetWallpaperCalculator(container);
    });
    radioButtons.forEach(function(radioButton) {
        radioButton.checked = false;
        if (radioButton.dataset.quantity) radioButton.dataset.quantity = 0;
    });
    quantitySelectors.forEach(function(quantitySelector) {
        let option0 = quantitySelector.querySelector('option[value="0"]');
        quantitySelector.value = option0 ? 0 : 1;
        if (option0) option0.disabled = false;
        quantitySelector.classList.remove('quantity-add-to-cart');
        quantitySelector.classList.remove('disabled');
        quantitySelector.classList.remove('opacity-50');
        if (quantitySelector.tomselect) quantitySelector.tomselect.sync();
    });
    container.querySelectorAll('.custom-size input[type="number"]').forEach(function(input) {
        input.value = '';
        fireInputEvent(input, false);
    });
    if (confirmButton && !confirmButton.classList.contains('disabled')) confirmButton.classList.add('disabled');
    if (defaultSize) defaultSize.checked = true;
    if (defaultSizeContainer) defaultSizeContainer.classList.add('selected');
}

export function resetWallpaperCalculator(container)
{
    let calculator = container.querySelector('.wallpaper-calculator');
    let tool = calculator.querySelector('.wallpaper-calculator-tool');
    let result = calculator.querySelector('.wallpaper-calculator-result');
    let size = calculator.querySelector('input[name="size"]');
    let quantity = calculator.querySelector('.quantity');
    let glueComplement = document.querySelector('#product-page input[name="complement"][value="486"]');

    delete size.dataset.width;
    delete size.dataset.height;
    delete size.dataset.previewText;
    delete size.dataset.quantity;
    size.checked = false;
    quantity.value = 0;
    quantity.classList.remove('quantity-add-to-cart');
    glueComplement.dataset.quantity = 1;
    tool.classList.remove('d-none');
    result.classList.add('d-none');
}

export function resetPackOption(container)
{
    container.querySelectorAll('input[name="pack"]').forEach(function (input) {
        if (input.classList.contains('default')) {
            input.checked = true;
            input.nextElementSibling.classList.add('selected');
            fireChangeEvent(input, false);
        } else {
            input.checked = false;
            input.nextElementSibling.classList.remove('selected');
        }
    });
}

export function resetColorOption(container)
{
    container.querySelectorAll('input[name="color"]:not([type="hidden"])').forEach(function (input) {
        if (input.classList.contains('default-color')) {
            input.checked = true;
            input.nextElementSibling.classList.add('selected');
        } else {
            input.checked = false;
            input.nextElementSibling.classList.remove('selected');
        }
    });

    if (!container.querySelector('input[name="color"][type="hidden"]')) {
        renderPreviewImage(container.closest('.product-scope'), true, container.dataset.productIndex || 1);
    }
}

export function resetCustomizerOption(container)
{
    let customText = container.querySelector('textarea[name="customText"], input[name="customText"]');
    let customImage = container.querySelector('input[name="custom-image"]');
    let customImageFromWeb = container.querySelector('input[name="customImageFromWeb"]');
    let customPriceIncrement = container.querySelector('input[name="customPriceIncrement"]');
    let svgPersonalizedText = container.querySelector('input[name="svg-personalized-text"]');
    let generateSVGPersonalizedText = container.querySelector('input[name="generate-svg-personalized-text"]');
    let factor = container.querySelector('input[name="factor"]');
    let validateButton = container.querySelector('.validate');

    if (validateButton) validateButton.classList.add('disabled');
    if (customText) customText.value = '';
    if (customImageFromWeb) customImageFromWeb.checked = false;
    if (customImage) {
        container.querySelector('input[name="file-customImage"]').value = null;
        container.querySelector('input[name="display-custom-image"]').value = '';
        customImage.value = '';
    }
    if (customPriceIncrement) {
        if (customPriceIncrement.dataset.defaultStatus === 'checked') customPriceIncrement.checked = true;
        else customPriceIncrement.checked = false;
    }
    if (svgPersonalizedText) {
        svgPersonalizedText.dataset.svg = '';
        svgPersonalizedText.dataset.preview = '';
    }
    if (generateSVGPersonalizedText) {
        generateSVGPersonalizedText.dataset.svgFile = '';
        generateSVGPersonalizedText.value = '';
    }
    if (factor) {
        factor.value = 0;
    }

    resetPreviewImage(container.closest('.product-scope'), true, container.dataset.productIndex || 1);
    renderPreviewImage(container.closest('.product-scope'), true, container.dataset.productIndex || 1);
}

export function resetGlassReversedOptions(container)
{
    container.querySelectorAll('input[name="glass-reversed"]').forEach(function (input) {
        let option = input.closest('.option-inline-selectable');
        input.checked = false;
        if (option) {
            option.classList.remove('selected');
            if (option.parentNode) option.parentNode.classList.remove('d-none');
        }
    });
}

export function resetOrientationOption(container)
{
    container.querySelectorAll('input[name="orientation"]').forEach(function (input) {
        let option = input.closest('.option-inline-selectable');
        if (input.classList.contains('default')) input.checked = true;
        else input.checked = false;
        if (option && option.parentNode) option.parentNode.classList.remove('d-none');
    });

    renderPreviewImage(container.closest('.product-scope'), true, container.dataset.productIndex || 1);
}

export function resetBlindTissueOption(container)
{
    container.querySelectorAll('input[name="tissue"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetBlindChainOption(container)
{
    container.querySelectorAll('input[name="chainPosition"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetBlindDropOption(container)
{
    container.querySelectorAll('input[name="drop"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetBlindSupportColor(container)
{
    container.querySelectorAll('input[name="support-color"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetModelOption(container)
{
    container.querySelectorAll('input[name="model"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetMaterialColorOption(container)
{
    let productIndex = container.dataset.productIndex;

    container.querySelectorAll('input[name="material-color"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });

    container.querySelectorAll('input[name="material-color"].default-material-color').forEach(function (input) {
        let bgColor = document.querySelector('#bg-color-'+productIndex);
        input.checked = true;
        input.nextElementSibling.classList.add('selected');
        if (bgColor) bgColor.value = input.dataset.colorCode;
        updateModelPreviews(container.closest('.product-scope'), input.value, productIndex);
    });

    renderPreviewImage(container.closest('.product-scope'), true, container.dataset.productIndex || 1);
}

export function resetModelSizeOption(container)
{
    container.querySelectorAll('input[name="model-size"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetFrameOption(container)
{
    let defaultFrame = container.querySelector('input[name="poster-frame"].default');

    container.querySelectorAll('input[name="poster-frame"]:not(.default)').forEach(function (input) {
        let label = input.nextElementSibling;
        input.checked = false;
        label.classList.remove('selected');
        if (!label.classList.contains('forced-disabled')) {
            input.disabled = false;
            label.classList.remove('frameClose');
        }
    });

    if (defaultFrame) {
        defaultFrame.checked = true;
        defaultFrame.nextElementSibling.classList.add('selected');
        fireChangeEvent(defaultFrame);
    }
}

export function resetMaterialCanvasOption(container)
{
    container.querySelectorAll('input[name="material-canvas"]:not([type="hidden"])').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });
}

export function resetVinylRugFormat(container)
{
    container.querySelectorAll('input[name="vinyl-rug-format"]').forEach(function (input) {
        input.checked = false;
        input.nextElementSibling.classList.remove('selected');
    });

    let defaultVinylRugFormat = container.querySelector('input[name="vinyl-rug-format"].default');
    if (defaultVinylRugFormat) {
        defaultVinylRugFormat.checked = true;
        defaultVinylRugFormat.nextElementSibling.classList.add('selected');
    }
}

export function resetComplements(container)
{
    container.querySelectorAll('.complement:not(.up-selling-personalized-text)').forEach(function (complement) {
        let input = complement.querySelector('input');
        if (input && input.name === 'customPriceIncrement') return;
        input.dataset.quantity = 1;
        input.checked = false;
    });

    container.querySelectorAll('.complements .complement:not(.up-selling-personalized-text)').forEach(function (complement, index) {
        if (index > 0) return;
        let input = complement.querySelector('input');
        input.checked = true;
    });
}

export function resetUpSellingPersonalizedText(container)
{
    let element = container.querySelector('.complement.up-selling-personalized-text');

    if (!element) return;

    let checkbox = element.querySelector('input[type="checkbox"]');

    checkbox.checked = false;
    fireChangeEvent(checkbox);
}

export function resetCrossSellings(container)
{
    container.querySelectorAll('.cross-selling').forEach(function (crossSelling) {
        let input = crossSelling.querySelector('input');
        input.dataset.quantity = 1;
        input.checked = false;
    });
}

export function updateModelPreviews(container, materialColor, productIndex)
{
    container.querySelectorAll('.options[data-product-index="'+productIndex+'"] .model').forEach(function(model) {
        let images = JSON.parse(model.dataset.images);
        let image = images[materialColor];
        if (image) model.querySelector('img').src = image;
    });
}

export async function updateSizesPrices(container)
{
    let productId = container.dataset.productId;
    let productIndex = container.dataset.productIndex || 1;
    let prices = await getSizesPrices(container);

    //CATALOG SIZES
    prices.forEach(function (element) {
        let id = element.id;
        let price = element.price;
        let oldPrice = element.oldPrice;
        let quantitiesDiscount = element.quantitiesDiscount;
        let input = container.querySelector(`.options[data-type="size"][data-product-index="${productIndex}"] input[name="size"][value="${id}"]`);
        let quantitySelector = input.nextElementSibling.querySelector('.quantity-selector');

        if (input) {
            let label = container.querySelector(`label[for="${input.id}"]`);

            input.dataset.price = price;
            label.querySelector('.size-price').innerHTML = price;
            if (oldPrice) {
                input.dataset.oldPrice = oldPrice;
                label.querySelector('.size-old-price').innerHTML = oldPrice;
            }
        }

        if (quantitySelector && quantitiesDiscount) {
            quantitiesDiscount.forEach(function (quantityDiscount) {
                let quantity = quantityDiscount.quantity;
                let text = quantityDiscount.text;
                let price = quantityDiscount.price;
                let tomselectOption = quantitySelector.tomselect.getOption(quantity);
                let option = quantitySelector.querySelector(`option[value="${quantity}"]`);

                if (tomselectOption) tomselectOption.querySelector('.item-price').innerHTML = text;
                if (option) {
                    option.dataset.rawPrice = price;
                    option.dataset.price = text;
                }
            });
        }
    });

    //CUSTOM SIZE
    let customSizeInput = container.querySelector(`.options[data-type="size"][data-product-index="${productIndex}"] input[name="size"][value="custom-size"]`);
    if (customSizeInput && customSizeInput.dataset.width && customSizeInput.dataset.height) {
        let customSizeContainer = customSizeInput.closest('.custom-size');
        let width = customSizeInput.dataset.width;
        let height = customSizeInput.dataset.height;
        let pack = container.querySelector(`input[name="pack"]:checked`);
        let color = container.querySelector(`input[name="color"]:checked`);
        let supportColor = container.querySelector(`input[name="support-color"]:checked`);
        let responseCalculatePrice = await calculateCustomSizePrice(
            productId,
            width,
            height,
            pack ? pack.value : null, 
            color ? color.value : null,
            supportColor ? supportColor.value : null
        );
        let price = responseCalculatePrice.price;
        price = formatPrice(price);
        customSizeContainer.querySelectorAll('.custom-price').forEach(function(priceContainer) {
            priceContainer.querySelector('.price, .value').innerHTML = price;
        });
    }
}

export function updateExclusivePremiumProduct(container)
{
    let isPremium = isPremiumUser();

    if (!container.classList.contains('exclusive-premium') || isPremium) return;

    container.querySelector('.add-to-cart').classList.add('d-none');
    container.querySelector('.premium-subscribe').classList.remove('d-none');
}

export function showImageSliderLoader()
{
    let imageSlider = document.querySelector('#product-page .image-slider');
    if (!imageSlider) return;

    let loader = imageSlider.parentElement.querySelector('.loader');
    if (!loader || !loader.classList.contains('d-none')) return;

    loader.classList.remove('d-none');
}

export function hideImageSliderLoader()
{
    let imageSlider = document.querySelector('#product-page .image-slider');
    if (!imageSlider) return;

    let loader = imageSlider.parentElement.querySelector('.loader');
    if (!loader || loader.classList.contains('d-none')) return;

    loader.classList.add('d-none');
}